import { createModel } from "@rematch/core";
import { KoreModel } from "./";
import { DesktopComponent } from "types";

type Plugin = DesktopComponent & {
  components: Map<string, DesktopComponent>;
};

export type Components = Record<string, Plugin>;

const model = {
  name: "components",
  state: {} as Components,
  reducers: {
    setComponents: (currentState: Components, data: Components) => {
      return { ...data };
    },
    updateComponent: (currentState: Components, name: string, component: DesktopComponent) => {
      const newState = { ...currentState };

      Object.values(newState).forEach((plugin) => {
        Array.from(plugin.components).forEach(([key, comp]) => {
          if (comp.name === name) comp = component;
        });
      });

      return newState;
    }
  }
};

export const componentsModel = createModel<KoreModel>()(model);
